import { OptionType as OptionTypeBase } from '../CommonComponents/OPL/Select/BaseSelect/types';

export enum ColumnWidths {
  Name = 18,
  LastModified = 4,
  FileSize = 3,
  Actions = 1,
}

/**
 * Max file size in MB
 */
export const MAX_FILE_SIZE = 100;

/**
 * Max number of sub-folders
 */
export const MAX_SUB_FOLDER_COUNT = 10;

/**
 * Max folder name length (number of chars)
 */
export const MAX_FOLDER_NAME_LENGTH = 64;

export const LEARN_MORE_LINK =
  'https://orionadvisorservices.my.site.com/OrionSupportApp/s/article/Data-Protection-and-Security-for-Orion-Planning';

export const FOLDER_404_ERROR = 'Folder does not exist.';

export const HOME_PATH = '';

export enum ExternalFolder {
  PortfolioStatements = 'Portfolio Statements',
  FidelityDocuments = 'Fidelity Documents',
  PershingDocuments = 'Pershing Documents',
  SchwabDocuments = 'Schwab Documents',
  AxosDocuments = 'Axos Documents',
  GoldmanSachsDocuments = 'Goldman Sachs Documents',
}

export enum ProviderType {
  All,
  Internal,
  External,
  CloudStorage,
}

export interface UploadProgressRef {
  onUploadProgress(p: any): void;
  onUploadSuccess(): void;
  bindOnCancel(controller: AbortController): void;
  onCancel(): void;
  onError(): void;
}

export const filterableYears = Array.from(
  { length: 10 },
  (_, limit) => new Date().getFullYear() - limit,
).map(year => ({
  label: year.toString(),
  value: year,
}));

export type FilterableYearOption = OptionTypeBase<number>;

export enum AuthenticationAuthorityDTO {
  FidelityDocuments = 'FidelityDocuments',
}

export enum EntityTypeDTO {
  File = 'File',
  Folder = 'Folder',
  Video = 'Video',
}

export interface EntityDTO {
  externalFileId: string | null;
  isReadOnly: boolean;
  isRenameable: boolean;
  lastModified: string | null;
  name: string;
  path: string;
  providerType: ProviderType;
  size: string | null;
  type: EntityTypeDTO;
  objectUrl: string | null;
  filterableByYear: boolean;
  isFromExternalSource: boolean;
  isDeletable: boolean;
  authenticationAuthority: AuthenticationAuthorityDTO;
  authenticationProfileModalEnabled: boolean;
  requestUserAuthentication: boolean;
  forceYear?: number;
  areItemsInsideReadOnly: boolean;
}

export interface EntitiesDTO {
  filterableByYear: boolean;
  isReadOnly: boolean;
  isWritable: boolean;
  path: string | null;
  providerType: ProviderType;
  items: EntityDTO[];
}

export interface SearchObjectsResponseDTO {
  query: string;
  isTruncated: boolean;
  providerType: ProviderType;
  items: EntityDTO[];
}
